export enum LevelType {
    price = 1,
    dm = 2
}
